import { dataLayerPush } from '@r1-frontend/analytics/dataLayerPush';
import { getCategories } from '@r1-frontend/api-domru/api-epg/v1/channel-categories';
import { getChannels as getAllChannelsRequest } from '@r1-frontend/api-domru/api-epg/v1/channels';
import { doRequest } from '@r1-frontend/do-request';
import { EVENTS } from '@r1-frontend/shared/constants/analytics';

import { searchCategory } from '~/src/components/Bundles/helpers';
import {
    APPLY_CHANNELS_FILTERS,
    CHANNELS_PACKAGE_ID,
    CLEAR_CHANNELS_PACKAGE_ID,
    CLEAR_SEARCH_CHANNELS_FILTER,
    CLEAR_THEME_CHANNELS_FILTER,
    GET_ALL_CHANNELS,
    GET_BUNDLES_BANNER,
    GET_BUNDLES_TARIFFS,
    GET_BUNDLES_TARIFFS_SELF_ORDER,
    GET_CHANNEL_THEMES,
    GET_TARIFF_LINES,
    SET_FILTER_FOR_CHANNELS,
    SET_FILTERED_TARIFFS_ID,
    SET_SEARCH_CHANNELS_FILTER,
    SET_SELECTED_TARIFF_ID,
    SET_TARIFF_CHANNELS,
    SET_THEME_CHANNELS_FILTER,
} from '~/src/store/actionTypes/bundles';
export const saveBanner = banner => ({
    type: GET_BUNDLES_BANNER,
    payload: banner,
});

export const changeChannelsBundleId = (id) => ({
    type: CHANNELS_PACKAGE_ID,
    payload: id,
});

export const clearChannelsBundleId = () => ({
    type: CLEAR_CHANNELS_PACKAGE_ID,
});

export const saveTariffs = (tariffs, selfOrder = false) => ({
    type: selfOrder ? GET_BUNDLES_TARIFFS_SELF_ORDER : GET_BUNDLES_TARIFFS,
    payload: tariffs,
});

export const saveTariffLinesAvailableOnBundles = (lines) => ({
    type: GET_TARIFF_LINES,
    payload: lines,
});

const saveAllChannels = (channels) => ({
    type: GET_ALL_CHANNELS,
    payload: channels,
});

/**
 * Получение списка всех каналов
 * @param providerId
 * @returns {Function}
 */
export function getAllChannels(providerId) {

    return async(dispatch) => {
        const response = await doRequest.apiEPG(
            getAllChannelsRequest(providerId, { with: 'category,channelInfo,packets' }),
        );
        if (response.isSuccess) {
            const data = response.payload.map(channel => {
                return ({
                    ...channel,
                    button: channel.lcn,
                    logo: channel?.channelInfo?.logo,
                    chid: channel.channelId,
                    xvid: channel.epgId,
                    display: channel.display.toString(),
                    bids: channel.packets.map(({ billing_id }) => (billing_id || '').toString()),
                    thid: (channel?.category?.id || '').toString(),
                });
            });

            dispatch(saveAllChannels(data));
        }
    };
}

const applyChannelsFilters = () => ({
    type: APPLY_CHANNELS_FILTERS,
});

const setSearchChannelFilter = (searchValue) => ({
    type: SET_SEARCH_CHANNELS_FILTER,
    payload: searchValue,
});

/**
 * Поиск каналов
 * @param searchValue поисковое слово
 * @returns {Function}
 */
export function searchChannels(searchValue) {
    return async(dispatch) => {
        try {
            if (!searchValue) {
                return;
            }

            dispatch(setSearchChannelFilter(searchValue));
            dispatch(applyChannelsFilters());
            dataLayerPush({
                event: EVENTS.UAevent,
                category: 'Click Bundles on the channel', 'action': 'search',
            });
        } catch (error) {
            console.info('Action: searchChannels error', error.message || error);
        }
    };
}

/**
 * Очищение поискового фильтра
 * @returns {{type: string}}
 */
export function clearSearchChannels() {
    return async(dispatch) => {
        try {
            dispatch(clearSearchChannelFilter());
            dispatch(applyChannelsFilters());
        } catch (error) {
            console.info('Action: clearSearchChannels error', error.message || error);
        }
    };
}

const setChannelsThemeFilter = (themeId) => ({
    type: SET_THEME_CHANNELS_FILTER,
    payload: themeId,
});

/**
 * Фильтруем каналы по теме
 * @param themeId
 * @returns {Function}
 */
export function filterChannelsByTheme(themeId) {
    return async(dispatch) => {
        try {
            dispatch(setChannelsThemeFilter(themeId));
            dispatch(applyChannelsFilters());
        } catch (error) {
            console.info('Action: filterChannelsByTheme error', error.message || error);
        }
    };
}

const clearChannelThemeFilter = () => ({
    type: CLEAR_THEME_CHANNELS_FILTER,
});

/**
 * Очищаем фильтр по теме
 * @returns {Function}
 */
export function clearChannelThemeSelection() {
    return async(dispatch) => {
        try {
            dispatch(clearChannelThemeFilter());
            dispatch(applyChannelsFilters());
        } catch (error) {
            console.info('Action: clearChannelThemeFilter error', error.message || error);
        }
    };
}

export const clearSearchChannelFilter = () => ({
    type: CLEAR_SEARCH_CHANNELS_FILTER,
});

const saveChannelThemes = (themes) => ({
    type: GET_CHANNEL_THEMES,
    payload: themes,
});

/**
 * Получение список тематик для каналов
 * @returns {Function}
 */
export function getChannelThemes() {
    return async(dispatch, getState) => {
        const channelThemes = getState().bundles.channelThemes;
        const providerId = getState().city.provider.providerId;
        if (channelThemes && channelThemes.length) {
            return;
        }

        const response = await doRequest.apiEPG(
            getCategories(providerId, { order: '+weight', with: 'channels' }),
        );
        if (response.isSuccess) {
            const formattedThemes = response.payload.map(theme => ({
                value: theme.rndId,
                id: theme.rndId,
                label: theme.name,
                name: theme.name,
                weight: theme.weight,
                channels: (theme.channels || []).map(channel => ({
                    ...channel,
                    isHd: channel.quality === 'HD',
                    id: channel.epgId,
                    logo: channel?.channelInfo?.logo,
                })),
            }));

            dispatch(saveChannelThemes(formattedThemes));
        }
    };
}

const saveTariffChannels = (packages) => ({
    type: SET_TARIFF_CHANNELS,
    payload: packages,
});

/**
 * Получение пакетов телеканалов, по нему сможем опеределить
 * какие каналы входят в определенный пакет
 * @param {number | string | number[] | string[]} freePackets Пакеты каналов
 * @returns {Function}
 */
export function getChannelPackages(freePackets) {
    return async(dispatch) => {
        try {
            const packagesIds = Array.isArray(freePackets)
                ? freePackets.map(String)
                : String(freePackets).split(',');

            dispatch(saveTariffChannels(
                {
                    packages: [...new Set(packagesIds)],
                    isOfferChannels: false,
                },
            ));
        } catch (error) {
            console.info('Action: getChannelPackages error', error.message || error);
        }
    };
}

/**
 * Получение пакетов телеканалов для определённго СП (оффера)
 * @param {string, string[], number[] | undefined} freePackets Пакеты каналов
 * @returns {Function}
 */
export function getOfferChannelPackages(freePackets) {
    return async(dispatch) => {
        try {
            dispatch(saveTariffChannels(
                {
                    packages: [...new Set(freePackets)],
                    isOfferChannels: true,
                },
            ));
        } catch (error) {
            console.info('Action: getOfferChannelPackages error', error.message || error);
        }
    };
}

export const setSelectedTariffIdAction = selectedTariffId => ({
    type: SET_SELECTED_TARIFF_ID,
    payload: selectedTariffId,
});

export const setFilterForChannelsAction = selectedFilter => ({
    type: SET_FILTER_FOR_CHANNELS,
    payload: selectedFilter,
});

export function setFilteredTariffsIdActions(filteredTariffsId) {
    return ({
        type: SET_FILTERED_TARIFFS_ID,
        payload: filteredTariffsId,
    });
}

/**
 * Смена темы каналов и фильтрация каналов в зависимости от выбранной темы
 * @returns {Function}
 */

export const onChangeChannelThemeAction = (data, channelThemes) => {
    return async(dispatch) => {
        try {
            const theme = typeof data === 'string' ? searchCategory(channelThemes, data) : data;

            if (theme.value === 0) {
                dispatch(clearChannelThemeSelection());
                dispatch(changeChannelsBundleId(theme.value));
            } else {
                dispatch(filterChannelsByTheme(theme.value));
                dispatch(changeChannelsBundleId(theme.value));
            }

            dispatch(setFilterForChannelsAction(theme));

            dataLayerPush({
                event: EVENTS.UAevent,
                category: 'Click Bundles on the channel',
                action: 'Filter_сhannel',
                label: theme.label,
            });
        } catch (error) {
            console.info('Action: onChangeChannelThemeAction error', error.message || error);
        }
    };
};
